export default "__VITE_ASSET__UtRP86Y8B13zQBF_yrB5kw__"